// import React, { useMemo } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'

import PageTitle from 'components/atoms/PageTitle'
import RepriceTable from 'components/organisms/RepriceTable'

// import { ROLE_READ_ONLY, ROLE_PARTNER_READ_ONLY, useAuth } from '../../auth'

export default function PartnerInventory() {
  const { t } = useTranslation()
  // const { hasOneOfRoles } = useAuth()
  // const userRoleHasReadOnly = useMemo(
  //   () => hasOneOfRoles([ROLE_READ_ONLY, ROLE_PARTNER_READ_ONLY]),
  //   [hasOneOfRoles]
  // )

  return (
    <Box className="content-container wide">
      <PageTitle label={t('inventoryReprice.title')} />
      <RepriceTable />
    </Box>
  )
}
